import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { roomMasterActions } from "../../../core/actions";
import { doctorActions } from "../../../core/actions";
import TextField from "@mui/material/TextField";
import {
  Grid,
  Select,
  MenuItem,
  FormControl,
  IconButton,
  FormHelperText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { List } from "@mui/material";
import { Alert } from "@mui/material";
import Button from "@mui/material/Button";
import { useOrganization } from "../../../configurations/OrganizationContext";
import useDynamicFontFormatter from "../../../shared/helper/useDynamicFontFormatter";
import { helperServices } from "../../../shared/helper";
import { ROOM_CATEGORIES } from "../../../shared/constants";

function RoomMasterAdd(props) {
  const dispatch = useDispatch();
  const org = useOrganization();
  const formatText = useDynamicFontFormatter(org?.fontStyle);
  const [addFlag, setTextFlag] = useState(false);
  const [submitted, setSubmitted] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [displayServices, setDisplayServices] = useState([]);
  const [formErrors, setFormErrors] = useState({
    roomName: "",
    roomCode: "",
    floorId: "",
    packageServiceName: "",
    packageId: "",
    roomCategory: "",
  });

  const [roomDetail, setRoomDetail] = useState({
    id: "",
    roomName: "",
    roomCode: "",
    type: "",
    uby: null,
    phone2: "",
    description: "",
    floorId: "",
    facilityId: "",
    section: "",
    cby: null,
    floorName: "",
    packageServiceId: "",
    packageServiceName: "",
    luxuryLevelId: "",
    luxurylevelName: "",
    packageId: "",
    roomCategory: "",
    emergencystatus: false,
  });

  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const [luxurylevelList, setluxurylevelList] = useState([]);
  const [option, setOption] = useState([]);
  const [packageList, setPackageList] = useState([]);
  const noFormatFields = [
    "floorId",
    "luxuryLevelId",
    "packageId",
    "roomCategory",
    "emergencystatus",
  ];

  const handleInputChange = (name, value) => {
    formErrors[name] = "";
    console.log("name, value", name, value);
    setRoomDetail((prev) => ({
      ...prev,
      [name]: noFormatFields.includes(name) ? value : formatText(value),
      ...(name === "roomCategory"
        ? {
            emergencystatus: value === ROOM_CATEGORIES.EMERGENCY_ROOM,
          }
        : {}),
    }));

    if (name === "packageServiceName") {
      if (value.length > 2) {
        searchService(value);
      } else {
        setDisplayServices([]);
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    let errors = {};

    Object.keys(roomDetail).forEach((key) => {
      const error = validateField(key, roomDetail[key], true); // pass a flag to return errors
      if (error) {
        errors[key] = error;
      }
    });

    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      // no errors → safe to submit
      validateForm();
    }
  };
  const validateField = (fieldName, value, returnError = false) => {
    let error = "";

    const currentDate = new Date().toISOString().split("T")[0];

    switch (fieldName) {
      case "roomName":
        error = value ? "" : "Please Enter Room Name";
        break;
      case "roomCode":
        error = value ? "" : "Please Enter Room Code";
        break;
      // case "packageServiceName":
      //   error = value ? "" : "Please choose the appropriate Package Service";
      //   break;
      case "floorId":
        error =
          value !== null && value !== undefined && value !== ""
            ? ""
            : "Please enter floorId";
        break;
      case "luxuryLevelId":
        error = value ? "" : "Please select luxuryLevel";
        break;
      case "packageId":
        error = value ? "" : "Please select package";
        break;
      case "roomCategory":
        error = value ? "" : "Please select room category";
        break;
      default:
        break;
    }

    if (returnError) return error;

    setFormErrors((prev) => ({ ...prev, [fieldName]: error }));
  };

  const validateForm = (event) => {
    const payload = { ...roomDetail };
    payload.cby = helperServices.getLoggedUserName();
    if (props.location?.state?.rowData) {
      payload.uby = helperServices.getLoggedUserName();
      dispatch(
        roomMasterActions.modifyRoom(payload, (resCb) => {
          // if (resCb) props.history.push("/roomMasterList");
          if (resCb.successMessages) {
            setServerRes({ success: resCb.successMessages, error: "" });
          } else if (resCb.errorMessages) {
            setServerRes({ success: "", error: resCb.errorMessages });
          }
          setTimeout(() => {
            props.history.push("/roomMasterList");
            closeAlert();
          }, 3000);
        })
      );
    } else {
      dispatch(
        roomMasterActions.addRoom(payload, (resCb) => {
          if (resCb.successMessages) {
            setServerRes({ success: resCb.successMessages, error: "" });
          } else if (resCb.errorMessages) {
            setServerRes({ success: "", error: resCb.errorMessages });
          }
          setTimeout(() => {
            props.history.push("/roomMasterList");
            closeAlert();
          }, 3000);
        })
      );
    }
  };

  useEffect(() => {
    getServiceList();
    getLuxuryLevelLists();
    if (props.location?.state?.rowData) {
      setTextFlag(!addFlag);

      const rowData = props.location.state.rowData;

      setRoomDetail((prev) => ({
        ...prev,
        ...rowData,
        roomCategory: rowData.roomCategory || "",
        emergencystatus:
          rowData.roomCategory === ROOM_CATEGORIES.EMERGENCY_ROOM,
      }));
    }
  }, []);

  const getServiceList = () => {
    dispatch(
      doctorActions.getServiceList({}, (resCb) => {
        if (resCb?.packageServiceList) {
          setServiceList(resCb.packageServiceList);
        }

        if (resCb?.packageList) {
          const packageArray = resCb.packageList.map((pack) => ({
            id: pack.id,
            name: pack.name,
          }));

          setPackageList(packageArray);
          setOption(packageArray);

          console.log("Transformed packages:", packageArray);
        }
      })
    );
  };

  const searchService = (query) => {
    const filtered = serviceList
      .map((item) => ({
        name: ["Doctor Charge", "Hospital Charge"].includes(item.name)
          ? `${item.packagename || item.name}: ${item.name}`
          : item.name,
        id: item.id,
        amount: item.amount,
        description: item.description,
      }))
      .filter((service) =>
        service.name?.toLowerCase().startsWith(query.toLowerCase())
      );
    setDisplayServices(filtered);
  };

  const toggle = () => props.history.push("/roomMasterList");

  const serviceSelected = (service) => {
    setRoomDetail((prev) => ({
      ...prev,
      packageServiceId: service.id,
      packageServiceName: service.name,
    }));
    setDisplayServices([]);
  };

  const getLuxuryLevelLists = () => {
    dispatch(
      roomMasterActions.getLuxuryLevelLists((resCb) => {
        if (resCb) setluxurylevelList(resCb.luxuryLevelLists);
      })
    );
  };
  const closeAlert = (e) => {
    setServerRes({ ..."" });
  };

  // Standard input style
  const inputStyle = { height: "40px" };

  return (
    <>
      {ServerRes.error && (
        <Alert severity="error" className="alert-div">
          {ServerRes.error}
          <IconButton size="small" onClick={closeAlert}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}

      {ServerRes.success && (
        <Alert severity="success" className="alert-div">
          {ServerRes.success}
          <IconButton size="small" onClick={closeAlert}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}

      <div className="mainsection">
        <h5>{addFlag ? "Edit" : "Add"} Room</h5>
        <main className="mainsection">
          <List>
            <div className="p-2 bg-none">
              <form>
                {/* Row 1 */}
                <Grid container spacing={2} className="local-grid-override">
                  <Grid item md={4}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Room Name"
                      value={roomDetail.roomName}
                      onChange={(e) =>
                        handleInputChange("roomName", e.target.value)
                      }
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.roomName}
                        </span>
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <FormControl fullWidth className="py-2">
                      <Select
                        displayEmpty
                        value={roomDetail.luxuryLevelId}
                        onChange={(e) =>
                          handleInputChange("luxuryLevelId", e.target.value)
                        }
                        sx={{ height: "40px" }}
                      >
                        <MenuItem value="">-Select Luxurylevel-</MenuItem>
                        {luxurylevelList.map((opt, idx) => (
                          <MenuItem key={idx} value={opt.id}>
                            {opt.luxurylevel}
                          </MenuItem>
                        ))}
                      </Select>
                      {formErrors.luxuryLevelId && (
                        <FormHelperText style={{ color: "#EC4147" }}>
                          {formErrors.luxuryLevelId}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item md={4}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Room Code"
                      value={roomDetail.roomCode}
                      onChange={(e) =>
                        handleInputChange("roomCode", e.target.value)
                      }
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.roomCode}
                        </span>
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                </Grid>

                {/* Row 2 */}
                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 0 }}
                  className="local-grid-override"
                >
                  <Grid item md={4}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Type"
                      value={roomDetail.type}
                      onChange={(e) =>
                        handleInputChange("type", e.target.value)
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Section"
                      value={roomDetail.section}
                      onChange={(e) =>
                        handleInputChange("section", e.target.value)
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                  <Grid item md={4} style={{ position: "relative" }}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Package Service"
                      value={roomDetail.packageServiceName}
                      onChange={(e) =>
                        handleInputChange("packageServiceName", e.target.value)
                      }
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.packageServiceName}
                        </span>
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                    {displayServices.length > 0 && (
                      <div
                        className="mt-2 shadow product-list-container position-absolute"
                        style={{
                          width: "100%", // 👈 Full width of parent Grid item
                          zIndex: 10,
                          backgroundColor: "#e9edef",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          left: 0,
                          top: "100%",
                          // ❌ Remove marginLeft — it breaks alignment
                        }}
                      >
                        {displayServices.map((service, index) => (
                          <div
                            key={index}
                            className="border-bottom blog-comments__item d-flex p-2 cpointer flex-wrap border-0 justify-content-between"
                            onClick={() => serviceSelected(service, index)}
                            style={{ cursor: "pointer" }}
                          >
                            <span className="mb-0">{service.name}</span>
                            <span className="text-muted">
                              Rs. {service.amount}
                            </span>
                            <span className="text-muted">
                              {service.description}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </Grid>
                </Grid>

                {/* Row 3 */}
                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 0 }}
                  className="local-grid-override"
                >
                  <Grid item md={4}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Floor Id"
                      value={roomDetail.floorId}
                      onChange={(e) =>
                        handleInputChange("floorId", e.target.value)
                      }
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.floorId}
                        </span>
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Floor Name"
                      value={roomDetail.floorName}
                      onChange={(e) =>
                        handleInputChange("floorName", e.target.value)
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <FormControl fullWidth className="py-2">
                      <Select
                        displayEmpty
                        value={roomDetail.packageId}
                        onChange={(e) =>
                          handleInputChange("packageId", e.target.value)
                        }
                        sx={{ height: "40px" }}
                      >
                        <MenuItem value="">-Select Package-</MenuItem>
                        {packageList.map((opt, idx) => (
                          <MenuItem key={idx} value={opt.id}>
                            {opt.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {formErrors.packageId && (
                        <FormHelperText style={{ color: "#EC4147" }}>
                          {formErrors.packageId}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 0 }}
                  className="local-grid-override"
                >
                  <Grid item md={4}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Description"
                      value={roomDetail.description}
                      onChange={(e) =>
                        handleInputChange("description", e.target.value)
                      }
                      variant="outlined"
                      multiline
                      minRows={1}
                      maxRows={3}
                      InputProps={{ style: { minHeight: "40px" } }}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <FormControl
                      fullWidth
                      className="py-2"
                      error={Boolean(formErrors.roomCategory)}
                    >
                      <Select
                        displayEmpty
                        value={roomDetail.roomCategory || ""}
                        onChange={(e) =>
                          handleInputChange("roomCategory", e.target.value)
                        }
                        sx={{ height: "40px" }}
                      >
                        <MenuItem value="">-Select Room Category-</MenuItem>

                        {Object.values(ROOM_CATEGORIES).map((category) => (
                          <MenuItem key={category} value={category}>
                            {category}
                          </MenuItem>
                        ))}
                      </Select>

                      {formErrors.roomCategory && (
                        <FormHelperText>
                          {formErrors.roomCategory}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>

                {/* Buttons */}
                <div
                  className="buttonsetconfirm"
                  style={{
                    marginTop: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "12px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="error"
                    onClick={toggle}
                    style={{ textTransform: "none" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    style={{ textTransform: "none" }}
                  >
                    Save
                  </Button>
                </div>
              </form>
            </div>
          </List>
        </main>
      </div>
    </>
  );
}

export default RoomMasterAdd;
